import { render, staticRenderFns } from "./Directness.vue?vue&type=template&id=2d9f40fa&"
import script from "./Directness.vue?vue&type=script&lang=ts&"
export * from "./Directness.vue?vue&type=script&lang=ts&"
import style0 from "./Directness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports